import { render } from "./InfoVerificationPage.vue?vue&type=template&id=a721effe&scoped=true"
import script from "./InfoVerificationPage.vue?vue&type=script&lang=js"
export * from "./InfoVerificationPage.vue?vue&type=script&lang=js"

import "./InfoVerificationPage.vue?vue&type=style&index=0&id=a721effe&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a721effe"]])

export default __exports__